import { css, Stack, styled, Typography } from '@mui/material';

export const SContainer = styled(Stack)(
  ({ theme }) => css`
    flex-direction: row;
    height: 100svh;

    ${theme.breakpoints.up('tablet')} {
      min-height: 100vh;
    }
  `,
);

export const SDesktopHint = styled(Typography)(({ theme }) => ({
  ...theme.typography['body-2-md'],
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  margin: '12px 16px 0',
  padding: '12px 44px 12px 14px',
  color: theme.palette.common.white,
  background: [
    'radial-gradient(120% 180% at 0% 0%, rgba(158, 32, 74, 0.45) 0%, transparent 55%)',
    'radial-gradient(120% 200% at 100% 0%, rgba(64, 86, 230, 0.55) 0%, transparent 60%)',
    '#141A2E',
  ].join(', '),
  borderRadius: 12,
}));

export const SDesktopHintClose = styled('button')({
  position: 'absolute',
  top: '50%',
  right: 10,
  display: 'flex',
  padding: 4,
  cursor: 'pointer',
  background: 'none',
  border: 0,
  transform: 'translateY(-50%)',
});
